import * as React from "react";

interface ParameterRowProps {
    name: string;
    oldValue: number;
    newValue: number;
}

export interface EcgTestParametersComparisonProps {
    oldQRS: number;
    newQRS: number;
    oldQT: number;
    newQT: number;
    oldPR: number;
    newPR: number;
    oldRR: number;
    newRR: number;
    oldST: number;
    oldPQ: number;
    oldP: number;
}

export const EcgTestParametersComparison = ({ oldQRS, newQRS, oldQT, newQT, oldPR, newPR, oldRR, newRR, oldST, oldPQ, oldP }: EcgTestParametersComparisonProps) => {
    const ParameterRow = ({ name, oldValue, newValue }: ParameterRowProps) => (
        <tr>
            <td>{name}</td>
            <td>
                {oldValue ? Math.round(oldValue) : "-"}
            </td>
            <td>
                {newValue ? Math.round(newValue) : "-"}
            </td>
        </tr>
    )

    return (
        <div className="col-md-6">
            <h3 className="text-primary"></h3>

            <table className="table table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th>Site</th>
                        <th>Overread</th>
                    </tr>
                </thead>
                <tbody>
                    <ParameterRow name="QRS (ms)" oldValue={oldQRS} newValue={newQRS} />
                    <ParameterRow name="QT (ms)" oldValue={oldQT} newValue={newQT} />
                    <ParameterRow name="PR (ms)" oldValue={oldPR} newValue={newPR} />
                    <ParameterRow name="RR (ms)" oldValue={oldRR} newValue={newRR} />
                    <ParameterRow name="ST (ms)" oldValue={oldST} newValue={null} />
                    <ParameterRow name="PQ (ms)" oldValue={oldPQ} newValue={null} />
                    <ParameterRow name="P (ms)" oldValue={oldP} newValue={null} />
                </tbody>
            </table>
        </div>
    );
}
